import axios from "axios"
import { instanceConfig } from "../config"

export const apiInstanceRemoteWorkplace = axios.create({
    ...instanceConfig,
    baseURL: `/remote-workplace-authentication-token`
})
